function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import '../scss/main.scss'; // IF we're in an iframe...

var isEmbedded = window.location !== window.parent.location; // You can write code specific to embeds like this...

if (isEmbedded) {
  try {
    window.childFrame.sendHeight();
  } catch (err) {
    console.log('pym not found.');
  }
}

import AnimationMaker from './AnimationMaker.js';
import lottieTemplate from './lottie_template.ejs';
import marked from 'marked';
import taiwan_map from './ai2html/taiwan_map.ejs';
import japan_map from './ai2html/japan_map.ejs';
var graphic_url_path = window.GRAPHIC_URL_PATH || '';
var gt = {
  gettext: function gettext(d) {
    return d;
  }
};
var ai2htmls = {
  taiwan_map: taiwan_map({
    gt: gt
  }),
  japan_map: japan_map({
    gt: gt
  })
};

for (var key in ai2htmls) {
  ai2htmls[key] = ai2htmls[key].replaceAll('img/graphics/', "".concat(graphic_url_path, "img/graphics/")).replaceAll('display:none;', "").replaceAll('&amp;', "&");
  /*
  let aiStyles =  ai2htmls[key].match(/(<style[\w\W]+style>)/g)
  aiStyles.forEach(function(styleString){
   styleString = styleString.replace('<style media="screen,print">',"").replace('</style>',"")
   console.log(styleString)
   let style = document.createElement('style');
   style.textContent = styleString;
   document.head.append(style);
  })
   ai2htmls[key].replace(/<style.*?<\/style>/g, '');
  */
} //IMPORT the main HTML


import article from './article.ejs';
import text from '../../locales/en/text.json';
var articleHTML = article({
  text: text,
  parseMarkdown: marked,
  graphic_url_path: graphic_url_path
});
var elem = document.getElementById('Main-Container');
elem.innerHTML = articleHTML; //IMpORt the ai2thml.

for (var _key in ai2htmls) {
  document.getElementById(_key).innerHTML = ai2htmls[_key]; //the script tags aren't rendering in this context, so i'm running those resizer scripts local.

  airesizer("g-".concat(_key, "-box"), {
    namespace: 'g-',
    setup: window.setupInteractive || window.getComponent
  });
}

var lottieObjects = {};
var targets = document.querySelectorAll('.lottie-target');
[].forEach.call(targets, function (el, i) {
  var id = el.getAttribute('id').split('lottie-')[1];

  var blurbs = _toConsumableArray(el.querySelectorAll('.blurb')).map(function (blrb) {
    return {
      text: blrb.innerHTML,
      seconds: blrb.getAttribute('seconds')
    };
  });

  el.querySelectorAll('.blurb').forEach(function (blrb) {
    return blrb.remove();
  });
  el.innerHTML += lottieTemplate({
    id: id,
    blurbs: blurbs
  });
  var sups = document.querySelectorAll('sup');
  var footnotes = document.querySelectorAll('.footnote');
  [].forEach.call(sups, function (el, i) {
    el.addEventListener('click', function (event) {
      var index = i + 1;
      document.getElementById("footnote".concat(index)).classList.add('selected');
      document.getElementById('footnote-shade').classList.add('selected');
    });
  });
  document.getElementById("footnote-shade").addEventListener('click', function (event) {
    document.getElementById('footnote-shade').classList.remove('selected');
    [].forEach.call(footnotes, function (el) {
      el.classList.remove('selected');
    });
  });
  [].forEach.call(footnotes, function (el) {
    el.addEventListener('click', function (event) {
      document.getElementById('footnote-shade').classList.remove('selected');
      [].forEach.call(footnotes, function (el) {
        el.classList.remove('selected');
      });
    });
  });

  if (i == targets.length - 1) {
    var anchors = document.querySelectorAll('.main-content a');
    [].forEach.call(anchors, function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        var href = event.target.getAttribute('href');
        window.open(href, '_blank');
      });
    });
  }

  lottieObjects[id] = new AnimationMaker({
    id: id,
    graphic_url_path: graphic_url_path,
    blurbs: blurbs,
    playbackConst: 50,
    widthRatio: 1.78,
    fullFrame: true,
    includeSmall: true,
    smallWidthRatio: 1
  });
});

function airesizer(containerId, opts) {
  if (!('querySelector' in document)) return;
  var container = document.getElementById(containerId);
  var nameSpace = opts.namespace || '';
  var onResize = throttle(update, 200);
  var waiting = !!window.IntersectionObserver;
  var observer;
  update();
  document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('resize', onResize); // NYT Scoop-specific code

  if (opts.setup) {
    opts.setup(container).on('cleanup', cleanup);
  }

  function cleanup() {
    document.removeEventListener('DOMContentLoaded', update);
    window.removeEventListener('resize', onResize);
    if (observer) observer.disconnect();
  }

  function update() {
    var artboards = selectChildren('.' + nameSpace + 'artboard[data-min-width]', container),
        width = Math.round(container.getBoundingClientRect().width); // Set artboard visibility based on container width

    artboards.forEach(function (el) {
      var minwidth = el.getAttribute('data-min-width'),
          maxwidth = el.getAttribute('data-max-width');

      if (+minwidth <= width && (+maxwidth >= width || maxwidth === null)) {
        if (!waiting) {
          selectChildren('.' + nameSpace + 'aiImg', el).forEach(updateImgSrc);
        }

        el.style.display = 'block';
      } else {
        el.style.display = 'none';
      }
    }); // Initialize lazy loading on first call

    if (waiting && !observer) {
      if (elementInView(container)) {
        waiting = false;
        update();
      } else {
        observer = new IntersectionObserver(onIntersectionChange, {});
        observer.observe(container);
      }
    }
  }

  function elementInView(el) {
    var bounds = el.getBoundingClientRect();
    return bounds.top < window.innerHeight && bounds.bottom > 0;
  } // Replace blank placeholder image with actual image


  function updateImgSrc(img) {
    var src = img.getAttribute('data-src');

    if (src && img.getAttribute('src') != src) {
      img.setAttribute('src', src);
    }
  }

  function onIntersectionChange(entries) {
    // There may be multiple entries relating to the same container
    // (captured at different times)
    var isIntersecting = entries.reduce(function (memo, entry) {
      return memo || entry.isIntersecting;
    }, false);

    if (isIntersecting) {
      waiting = false; // update: don't remove -- we need the observer to trigger an update
      // when a hidden map becomes visible after user interaction
      // (e.g. when an accordion menu or tab opens)
      // observer.disconnect();
      // observer = null;

      update();
    }
  }

  function selectChildren(selector, parent) {
    return parent ? Array.prototype.slice.call(parent.querySelectorAll(selector)) : [];
  } // based on underscore.js


  function throttle(func, wait) {
    var timeout = null,
        previous = 0;

    function run() {
      previous = Date.now();
      timeout = null;
      func();
    }

    return function () {
      var remaining = wait - (Date.now() - previous);

      if (remaining <= 0 || remaining > wait) {
        clearTimeout(timeout);
        run();
      } else if (!timeout) {
        timeout = setTimeout(run, remaining);
      }
    };
  }
}